/**
 * Refcounted body scroll lock. Modal and Drawer both lock the body while
 * open; a naive save/restore of `body.style.overflow` breaks when nested
 * locks release out of order (e.g. the drawer unmounts before the modal's
 * cleanup runs — the modal then restores `hidden` over the drawer's restore
 * and the page can never scroll again). A counter is order-independent:
 * the body is scrollable again only when the last lock releases.
 */
let locks = 0;

export function lockBodyScroll(): () => void {
  locks += 1;
  document.body.style.overflow = 'hidden';
  return () => {
    locks = Math.max(0, locks - 1);
    if (locks === 0) document.body.style.overflow = '';
  };
}
